import { Link } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { RuleSchema } from '@/types/schema';
import {
  appAnnotationQueuesPath,
  appDatasetsPath,
  appOrganizationPath,
} from '@/utils/constants';

export function RuleActionLabel({ rule }: { rule: RuleSchema }) {
  const organizationId = useOrganizationId();

  if (rule.add_to_annotation_queue_id) {
    return rule.add_to_annotation_queue_name ? (
      <span>
        Send to{' '}
        <Link
          className="text-ls-black hover:underline"
          to={`/${appOrganizationPath}/${organizationId}/${appAnnotationQueuesPath}/${rule.add_to_annotation_queue_id}`}
        >
          {rule.add_to_annotation_queue_name}
        </Link>{' '}
        annotation queue
      </span>
    ) : (
      'Send to annotation queue'
    );
  }

  if (rule.add_to_dataset_id) {
    return rule.add_to_dataset_name ? (
      <span>
        Send to{' '}
        <Link
          className="text-ls-black hover:underline"
          to={`/${appOrganizationPath}/${organizationId}/${appDatasetsPath}/${rule.add_to_dataset_id}`}
        >
          {rule.add_to_dataset_name}
        </Link>{' '}
        dataset
      </span>
    ) : (
      'Send to dataset'
    );
  } else if (rule.evaluators && rule.evaluators.length > 0) {
    return rule.dataset_id
      ? 'LLM-as-a-Judge Evaluator'
      : 'Online LLM-as-a-Judge Evaluator';
  } else if (rule.webhooks && rule.webhooks.length > 0) {
    return 'Webhooks';
  } else if (rule.extend_only) {
    return 'Extend Data Retention';
  } else if (rule.code_evaluators) {
    return rule.dataset_id ? 'Custom Evaluator' : 'Online Custom Evaluator';
  }

  return 'Disabled';
}
